const libDialogVirtualNumber = {
  namespaced: true,
  state: {
    requests: {}, // request集合
    buryPointFn: null,
    numberData: {},
    configUrl: {},
  },
  getters: {
    requests: (state) => state.requests,
    buryPointFn: (state) => state.buryPointFn,
    numberData: (state) => state.numberData,
    configUrl: (state) => state.configUrl,
  },
  mutations: {
    updateRequests(state, requests) {
      state.requests = requests;
    },
    updateBuryPointFn(state, buryPointFn) {
      state.buryPointFn = buryPointFn;
    },
    updateNumberData(state, numberData) {
      state.numberData = numberData;
    },
    updateConfigUrl(state, configUrl) {
      state.configUrl = configUrl;
    },
  },
  actions: {},
};
export default libDialogVirtualNumber;
